import { CDN_URL } from "../utils/constants";
const RestroCard = (props) => {
    const { name, avgRating, cloudinaryImageId, cuisines } = props;
    return (
        <div
            data-testid="resCard"
            className="restro-card w-full rounded-2xl bg-white shadow-md overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
        >
            <div className="overflow-hidden h-44">
                <img
                    alt={name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    src={CDN_URL + cloudinaryImageId}
                />
            </div>
            <div className="p-4">
                <h2 className="font-bold text-base text-gray-900 truncate">{name}</h2>
                <p className="text-gray-400 text-xs mt-1 truncate">
                    {Array.isArray(cuisines) ? cuisines.join(", ") : cuisines}
                </p>
                <div className="flex items-center gap-2 mt-3">
                    <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded">
                        ★ {avgRating}
                    </span>
                    <span className="text-gray-300 text-xs">• 30–40 min</span>
                </div>
            </div>
        </div>
    );
};

//higher order component
export const PromotedRestroCard = (RestroCard) => {
    return (props) => (
        <div className="relative">
            <span className="absolute top-3 left-3 z-10 bg-gray-900 text-white text-[10px] uppercase font-bold tracking-widest px-2 py-1 rounded shadow">
                Promoted
            </span>
            <RestroCard {...props} />
        </div>
    );
};
export default RestroCard;
